import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  LinearProgress,
  Chip,
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
} from '@mui/icons-material';

const StatsCard = ({
  title,
  value,
  icon,
  color = 'primary',
  trend,
  trendValue,
  subtitle,
  progress,
  chip,
}) => {
  const getTrendColor = () => {
    if (!trend) return 'text.secondary';
    return trend === 'up' ? 'success.main' : 'error.main';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? <TrendingUpIcon /> : <TrendingDownIcon />;
  };

  return (
    <Card
      sx={{
        height: '100%',
        background: `linear-gradient(135deg, ${color === 'primary' ? '#1976d2' : 
                                                color === 'secondary' ? '#dc004e' : 
                                                color === 'success' ? '#2e7d32' : 
                                                color === 'info' ? '#0288d1' :
                                                color === 'warning' ? '#ed6c02' : '#d32f2f'} 0%, 
                                               ${color === 'primary' ? '#42a5f5' : 
                                                color === 'secondary' ? '#ff5983' : 
                                                color === 'success' ? '#4caf50' : 
                                                color === 'info' ? '#03dac6' :
                                                color === 'warning' ? '#ff9800' : '#f44336'} 100%)`,
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 100,
          height: 100,
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          transform: 'translate(30px, -30px)',
        },
      }}
    >
      <CardContent sx={{ position: 'relative', zIndex: 1 }}>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={2}>
          <Box>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontWeight: 500,
                textTransform: 'uppercase',
                fontSize: '0.75rem',
                letterSpacing: '0.5px',
              }}
            >
              {title}
            </Typography>
            {chip && (
              <Chip
                label={chip}
                size="small"
                sx={{
                  mt: 0.5,
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  fontSize: '0.7rem',
                  height: 20,
                }}
              />
            )}
          </Box>
          <Avatar
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              width: 48,
              height: 48,
            }}
          >
            {icon}
          </Avatar>
        </Box>

        <Box mb={1}>
          <Typography
            variant="h4"
            component="div"
            sx={{
              fontWeight: 700,
              color: 'white',
              lineHeight: 1,
            }}
          >
            {typeof value === 'number' ? value.toLocaleString() : value}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                mt: 0.5,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {progress !== undefined && (
          <Box mb={1}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: 'white',
                },
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                mt: 0.5,
                display: 'block',
              }}
            >
              {progress}% del objetivo
            </Typography>
          </Box>
        )}

        {trend && (
          <Box display="flex" alignItems="center" mt={1}>
            <Box
              display="flex"
              alignItems="center"
              sx={{
                color: trend === 'up' ? '#4caf50' : '#f44336',
                backgroundColor: trend === 'up' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                borderRadius: 1,
                px: 1,
                py: 0.5,
              }}
            >
              {getTrendIcon()}
              <Typography
                variant="caption"
                sx={{
                  ml: 0.5,
                  fontWeight: 600,
                  color: 'inherit',
                }}
              >
                {trendValue}
              </Typography>
            </Box>
            <Typography
              variant="caption"
              sx={{
                ml: 1,
                color: 'rgba(255, 255, 255, 0.8)',
              }}
            >
              vs mes anterior
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
